<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <Modal
            :text="modalText"
            id="modal_router"
            :on-ok-pressed="goNext"
            :is-ok-only="false"
            ok-text="yes"
            cancel-text="no"
        />

        <FormTag v-if="!tableShow">
            <Alert class="text-center" v-if="alertInvalidExcel" :variant="'danger'">{{ alertText }}</Alert>

            <Alert class="text-center" v-if="isMobileApp()" v-html="$t('import.advice')" :variant="'warning'">
            </Alert>

            <Alert class="d-sm-none text-center" v-html="$t('import.advice')" v-if="!isMobileApp()"
                   :variant="'warning'">
            </Alert>

            <div v-if="isLoadingError" class="grid h-screen place-items-center">
                <span class="spinner-border text-primary" role="status" aria-hidden="true"></span>
            </div>
            <label v-else-if="!isError" for="excel" class="btn btn-primary mt-4 ml-4">{{ $t('excel.choiceExcelFile') }}</label>

            <input
                v-if="!isMobileApp() && !isError"
                id="excel"
                style="visibility: hidden"
                type="file"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                @change="importExcel($event)"
            >
        </FormTag>

        <Row type="none" v-else-if="!isError">
            <div v-if="getProductExcelValuesAmount" class="d-flex justify-content-between mb-4">
                <div class="col-4 d-flex align-items-center">
                    <span class="font-bold">{{
                        $t('statistics.yaxis')
                        }}:</span> {{
                        $t('productsInWarehouse.changingProductsAmount', {amount: getProductExcelValuesAmount})
                    }}
                </div>
                <div
                    class="d-flex col-5 align-items-center"
                    v-if="selected.find(v => v === 'boughtPrice') &&
                          selected.find(v => v === 'purchaseCurrency') &&
                          selected.find(v => v === 'amount') && !isPriceError
                     ">
                    <div class="mr-2"><span class="font-bold">{{ $t('totalSalesAmount') }}:</span> {{ getTotalSalesAmount() }}</div>
                    <b-form-select
                        class="col-3 border-gray-300 focus:ring-0"
                        @change="getTotalSalesAmount; excelFieldsSortedData.payedAmount = ''"
                        v-model="currentCurrencyShortName">
                        <b-form-select-option value="UZS">UZS</b-form-select-option>
                        <b-form-select-option value="USD">USD</b-form-select-option>
                        <b-form-select-option value="RUB">RUB</b-form-select-option>
                    </b-form-select>
                </div>
                <div
                    class="mt-2 mx-2 gap-3 btn-group btn-group-toggle flex justify-content-around"
                    data-toggle="buttons">
                    <label
                        @click="makePayed"
                        class="flex justify-content-center bg-blue-100 pay-type rounded h-14 w-16 cursor-pointer btn btn-primary hover:bg-blue-200 active">
                        <input type="radio" name="payed-or-credit" v-model="excelFieldsSortedData.isPayed" checked :disabled="isDisabled">
                        <span
                            :class="excelFieldsSortedData.isPayed ? 'text-xs text-white font-bold position-absolute bottom-1' : 'text-xs text-fontColor font-bold position-absolute bottom-1'">
                                    {{ $t('payed') }}
                                </span>
                        <img v-if="excelFieldsSortedData.isPayed" src="/images/hand-shake.png" alt="" class="h-9">
                        <img v-else src="/images/payed.png" alt="" class="h-5 mt-1">
                    </label>

                    <label
                        @click="makeUnPayed"
                        class="flex justify-content-center bg-red-100 pay-type rounded h-14 w-16 cursor-pointer btn btn-primary hover:bg-red-200">
                        <input type="radio" name="payed-or-credit" v-model="excelFieldsSortedData.isPayed" :disabled="isDisabled">
                        <span
                            :class="!excelFieldsSortedData.isPayed ? 'text-xs text-white font-bold position-absolute bottom-1' : 'text-xs text-fontColor font-bold position-absolute bottom-1'">
                                    {{ $t('onCredit') }}
                                </span>
                        <img src="/images/forDebt.png" alt="" class="h-7">
                    </label>
                </div>
            </div>
            <div
                v-if="getProductExcelValuesAmount && !excelFieldsSortedData.isPayed"
                class="container grid grid-cols-1 md:grid-cols-3 gap-3 mb-4">

                <div class="col-span-1 position-relative pl-0">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                        {{ $t('supplier.choose') }}
                    </div>
                    <v-select
                        class="p-0"
                        :options="getSuppliers"
                        :clearable="false"
                        v-model="excelFieldsSortedData.supplierForDebt"
                        :reduce="supplier => supplier['@id']"
                        :get-option-label="supplier =>
                            supplier.isCompany ? supplier.supplierCompany.name :
                            supplier.person.givenName + ' ' + supplier.person.familyName"
                    >
                        <template #no-options="{}">
                            {{ $t("selectError") }}
                        </template>
                    </v-select>
                </div>

                <div v-if="selected.find(v => v === 'boughtPrice') && selected.find(v => v === 'purchaseCurrency') && selected.find(v => v === 'amount')" class="col-span-1 position-relative my-3 my-md-0">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                        {{ $t("payedAmount") }}
                    </div>
                    <InputBox
                        class="border-gray-300 px-0"
                        model-name="payedAmount"
                        type="number"
                        :model-form="excelFieldsSortedData"
                    />
                </div>

                <div v-if="parseFloat(excelFieldsSortedData.totalPrice) - parseFloat(excelFieldsSortedData.payedAmount ? excelFieldsSortedData.payedAmount : '0') > 0" class="col-span-1 position-relative card h-11">
                    <div class="font-bold text-sm bg-white px-1 z-30 position-absolute -top-3 ml-2">
                        {{ $t('debt') }}
                    </div>

                    <div class="mt-2 ml-2 text-hoverDenyColor">
                        {{
                            showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, parseFloat(excelFieldsSortedData.totalPrice) - parseFloat(excelFieldsSortedData.payedAmount ? excelFieldsSortedData.payedAmount : '0'))
                        }}
                    </div>
                </div>
            </div>
            <Alert class="text-center" v-if="alertShow" :variant="'danger'">{{ alertText }}</Alert>
            <Alert v-else class="bg-lightGray border-0">
                <div class="text-center font-bold text-gray-700">
                    {{ $t('excel.selectEachColumn') }}
                </div>
            </Alert>

            <div class="table-responsive">
                <table class="table">
                    <thead class="h-11 bg-lightGray">
                    <tr>
                        <th v-for="(field, index) in getProductExcelFields" :key="index">

                            <select v-model="selected[index]" class="w-100 h-8 rounded text-xs">
                                <option v-for="option in options"
                                        :key="option.value"
                                        :value="option.value"
                                >
                                    {{ $t(option.text) }}
                                </option>
                            </select>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td class="font-weight-bold"
                            v-for="(field, index) in getProductExcelFields"
                            :key="index"
                        >
                            {{ field }}
                        </td>
                    </tr>
                    <tr
                        v-for="(values, index) in getProductExcelValues.slice(0, 5)"
                        :key="index"
                    >
                        <td
                            v-for="(value, index) in values"
                            :key="index"
                        >{{ value }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="container">
                <SubmitRow :is-disabled="disabled" :do-action="exportEditedExcel" :is-loading="isLoading"
                           :text="$t('excel.import')"/>
            </div>

        </Row>
    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Row from "@/components/html/Row";
import FormTag from "@/components/html/FormTag";
import SubmitRow from "@/components/SubmitRow";
import Alert from "@/components/html/Alert";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import vSelect from 'vue-select'
import '../../style/vue-select.css';
import InputBox from "../../components/InputBox";
import Modal from "@/components/html/Modal.vue";

export default {
    name: "Import",
    components: {
        Modal,
        Alert,
        Row,
        FormTag,
        SubmitRow,
        vSelect,
        InputBox
    },
    mixins: [currencyRateMixin, currencyFormatMixin],
    data() {
        return {
            isPriceError: false,
            isError: false,
            currentCurrencyShortName: this.baseCurrencyShortName,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'product.title', url: 'products'},
                {name: 'excel.import'},
            ],
            isLoadingError: false,
            isLoading: false,
            selected: [],
            modalText: '',
            next: null,
            options: [
                {text: 'excel.notImport', value: 'not_import'},
                {text: 'product.name', value: 'name'},
                {text: 'boughtPrice', value: 'boughtPrice'},
                {text: 'excel.purchaseCurrency', value: 'purchaseCurrency'},
                {text: 'sellingPrice', value: 'sellingPrice'},
                {text: 'excel.saleCurrency', value: 'saleCurrency'},
                {text: 'amount', value: 'amount'},
                {text: 'unitOfMeasure.short', value: 'unitOfMeasure'},
                {text: 'warehouse.title', value: 'warehouse'},
                {text: 'category', value: 'categories'},
                {text: 'supplier.title', value: 'supplier'},
                {text: 'product.barcode', value: 'barcode'}
            ],
            tableShow: false,
            alertInvalidExcel: false,
            alertShow: false,
            alertText: '',
            excelFieldsSortedData: {
                name: '',
                sellingPrice: '',
                saleCurrency: '',
                boughtPrice: '',
                purchaseCurrency: '',
                amount: '',
                unitOfMeasure: '',
                warehouse: '',
                categories: '',
                supplier: '',
                barcode: '',
                isPayed: true,
                payedAmount: null,
                supplierForDebt: null,
                totalPrice: null,
                currency: null
            }
        }
    },
    computed: {
        ...mapGetters([
            'getProductExcelId',
            'getProductExcelFields',
            'getProductExcelValues',
            'getProductEditedExcel',
            'getProductExcelValuesAmount',
            "getSuppliers"
        ]),
        disabled() {
            return !this.selected.find(v => v === 'unitOfMeasure') ||
                !this.selected.find(v => v === 'name') ||
                !this.selected.find(v => v === 'warehouse') ||
                !this.selected.find(v => v === 'purchaseCurrency') ||
                !this.selected.find(v => v === 'sellingPrice') ||
                !this.selected.find(v => v === 'amount') ||
                (this.excelFieldsSortedData.isPayed && !this.selected.find(v => v === 'supplier')) ||
                (!this.excelFieldsSortedData.isPayed && !this.excelFieldsSortedData.supplierForDebt)
        },
        isDisabled() {
            return !this.selected.find(v => v === 'boughtPrice') ||
                !this.selected.find(v => v === 'purchaseCurrency') ||
                !this.selected.find(v => v === 'amount')
        }
    },
    methods: {
        ...mapActions([
            'fetchSuppliers',
            'pushProductExcel',
            'fetchProductExcel',
            'pushProductEditedExcel',
            'setBreadcrumbItems'
        ]),
        makePayed() {
            if ( !this.selected.find(v => v === 'boughtPrice') ||
                !this.selected.find(v => v === 'purchaseCurrency') ||
                !this.selected.find(v => v === 'amount')) {
                return
            }

            this.excelFieldsSortedData.isPayed = true
        },
        makeUnPayed() {
            if ( !this.selected.find(v => v === 'boughtPrice') ||
                !this.selected.find(v => v === 'purchaseCurrency') ||
                !this.selected.find(v => v === 'amount')) {
                return
            }

            this.excelFieldsSortedData.isPayed = false
        },
        isMobileApp() {
            return window.isMobile()
        },
        getTotalSalesAmount() {
            let totalPrice = 0
            let currencyIndex = this.selected.findIndex(v => v === 'purchaseCurrency')
            let priceIndex = this.selected.findIndex(v => v === 'boughtPrice')
            let amountIndex = this.selected.findIndex(v => v === 'amount')

            this.getProductExcelValues.map(value => {
                totalPrice += this.calculateAmountByBaseCurrency(
                    parseFloat(value[priceIndex]) * parseFloat(value[amountIndex]),
                    value[currencyIndex],
                    this.currentCurrencyShortName
                )
            })

            if (isNaN(totalPrice)) {
                this.isPriceError = true
            }

            this.excelFieldsSortedData.totalPrice = totalPrice

            return this.showCurrencyByIdWithoutSymbol(
                this.getCurrencyByShortName(this.currentCurrencyShortName).id,
                totalPrice
            )
        },
        numToString(num) {
            num++
            let s = "", t;

            while (num > 0) {
                t = (num - 1) % 26;
                s = String.fromCharCode(65 + t) + s;
                num = (num - t) / 26 | 0;
            }
            return s || undefined;
        },
        defaultOption() {
            this.options.forEach(() => {
                this.selected.push(this.options[0].value)
            })
        },
        importExcel(event) {
            this.alertInvalidExcel = false
            this.isLoadingError = true
            this.file = event.target.files[0]

            const data = new FormData();
            data.append('file', this.file)

            this.pushProductExcel(data)
                .then(() => {
                    this.fetchProductExcel(this.getProductExcelId)
                        .then(() => {
                            setTimeout(() => this.tableShow = true, 3000)
                            setTimeout(() => this.tableShow = true, 3000)
                            this.defaultOption()

                        })
                        .catch((err) => {
                            if (err === 'Empty excel file is uploaded') {
                                this.alertText = this.$t('excel.validExcel')
                            } else {
                                this.alertText = err
                            }

                            this.isError = true
                            this.alertInvalidExcel = true
                            this.isLoadingError = false
                            setTimeout(() => {
                                this.$router.push('excel-error')
                                this.isError = false
                            }, 4000)
                        })
                })
                .catch((err) => {
                    if (err === 'file: Please upload a valid excel') {
                        this.alertText = this.$t('excel.validExcel')
                    } else {
                        this.alertText = err
                    }

                    this.isError = true
                    this.isLoadingError = false
                    this.alertInvalidExcel = true
                    setTimeout(() => {
                        this.$router.push('excel-error')
                        this.isError = false
                    }, 4000)
                })
        },
        exportEditedExcel() {
            this.isLoading = true

            this.selected.forEach(((value, index) => {
                switch (value) {
                    case 'name':
                        this.excelFieldsSortedData.name = this.numToString(index)
                        break;

                    case 'sellingPrice':
                        this.excelFieldsSortedData.sellingPrice = this.numToString(index)
                        break;

                    case 'saleCurrency':
                        this.excelFieldsSortedData.saleCurrency = this.numToString(index)
                        break;

                    case 'boughtPrice':
                        this.excelFieldsSortedData.boughtPrice = this.numToString(index)
                        break;

                    case 'purchaseCurrency':
                        this.excelFieldsSortedData.purchaseCurrency = this.numToString(index)
                        break;

                    case 'amount':
                        this.excelFieldsSortedData.amount = this.numToString(index)
                        break;

                    case 'unitOfMeasure':
                        this.excelFieldsSortedData.unitOfMeasure = this.numToString(index)
                        break;

                    case 'warehouse':
                        this.excelFieldsSortedData.warehouse = this.numToString(index)
                        break;

                    case 'categories':
                        this.excelFieldsSortedData.categories = this.numToString(index)
                        break;

                    case 'supplier':
                        this.excelFieldsSortedData.supplier = this.numToString(index)
                        break;

                    case 'barcode':
                        this.excelFieldsSortedData.barcode = this.numToString(index)
                        break;
                }
            }))

            this.excelFieldsSortedData.currency = this.getCurrencyByShortName(this.currentCurrencyShortName)['@id']
            this.excelFieldsSortedData.payedAmount = parseFloat(this.excelFieldsSortedData.payedAmount ? this.excelFieldsSortedData.payedAmount : '0')
            this.excelFieldsSortedData.totalPrice = parseFloat(this.excelFieldsSortedData.totalPrice ? this.excelFieldsSortedData.totalPrice : '0')

            this.pushProductEditedExcel({id: this.getProductExcelId, body: this.excelFieldsSortedData})
                .then(() => {
                    this.$router.push('excel-was-imported')
                })
                .catch((err) => {
                    let errorBody = err.slice(0, 36)

                    if (err === 'Has empty fields') {
                        this.alertText = this.$t('excel.hasEmptyFields')
                    } else if (errorBody === 'Invalid format of data in excel file') {
                        let errorWords = err.split(' ')

                        this.alertText =
                            this.$t('excel.checkData') + ': ' +
                            errorWords[7] + ' - ' +
                            this.$t('excel.row') + ', ' +
                            this.$t(errorWords[9])

                        this.tableShow = false
                        this.isError = true
                        this.alertInvalidExcel = true
                        this.isLoadingError = false

                        setTimeout(() => {
                            this.$router.push('excel-error')
                            this.isError = false
                        }, 10000)
                    } else {
                        this.alertText = this.$t('excel.checkData')
                    }
                    this.alertShow = true
                })
                .finally(() => {
                    this.isLoading = false
                    setTimeout(() => this.alertShow = false, 7000)
                })
        },
        goNext() {
            this.next()
        }
    },
    watch: {
        'excelFieldsSortedData.isPayed'() {
            if (this.excelFieldsSortedData.isPayed) {
                this.currentCurrencyShortName = this.baseCurrencyShortName
                this.excelFieldsSortedData.payedAmount = this.excelFieldsSortedData.totalPrice
                this.excelFieldsSortedData.supplierForDebt = null
            } else {
                this.excelFieldsSortedData.payedAmount = ''
                this.excelFieldsSortedData.supplierForDebt = this.getSuppliers[0]['@id']
            }
        },
        'excelFieldsSortedData.payedAmount'() {
            if (
                parseFloat(this.excelFieldsSortedData.payedAmount ? this.excelFieldsSortedData.payedAmount : '0') >=
                parseFloat(this.excelFieldsSortedData.totalPrice.toFixed(2))
            ) {
                this.excelFieldsSortedData.isPayed = true
            }
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        console.warn('IMPOSRT')
        this.fetchSuppliers(null)
            .then(() => {
                this.excelFieldsSortedData.supplierForDebt = this.getSuppliers[0]['@id']
            })
    },
    beforeRouteLeave (to, from , next) {
        if (this.getProductExcelFields === undefined) {
            next()
            return
        }

        if (this.getProductExcelFields.length > 0 && to.name !== 'excel-error' && to.name !== 'imported-excel') {
            this.modalText = this.$t('beforeLeaveAdvice')
            this.$bvModal.show('modal_router')
            this.next = next
        } else {
            next()
        }
    },
}
</script>

<style scoped>
.debt-amount {
    text-indent: 10px;
    font-weight: 600;
    color: #bd2130;
}

.pay-type {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
}
</style>
